import { TransportMode } from '@shared/models/transportMode';

export function getPlatformName(transportMode: TransportMode): string {
  if (transportMode === 'train') {
    return 'spår';
  }

  return 'läge';
}
